import React from 'react';
import { Table } from 'semantic-ui-react';
import * as classnames from 'classnames';

const SessionParticipant = props => {
  const invalidStates = ['noShow', 'invalid', 'exclusion', 'refused'];
  const invalidStateMessages = {
    noShow: 'No Show',
    invalid: 'Invalid',
    exclusion: 'Excluded',
    refused: 'Refused'
  };
  let participantId;
  let message;
  const isParticipationInvalid =
    props.participant && invalidStates.indexOf(props.participant.status) >= 0;

  const sessionStatusClassnames = classnames({
    'session__td--participant': !isParticipationInvalid,
    'session__td--participant__invalid': isParticipationInvalid
  });

  if (props.participant) {
    participantId = props.participant.identifier;
    if (isParticipationInvalid) {
      message = ` - ${invalidStateMessages[props.participant.status]}`;
    }
  }
  return (
    <Table.Cell className={sessionStatusClassnames}>
      <span>
        {participantId}
        {message}
      </span>
    </Table.Cell>
  );
};

export default SessionParticipant;



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/SessionParticipant.js